<div
  class="wrapper"
  [class.interaction-disabled]="serviceTicketStore.callTypeInteractionDisabled$ | async"
>
  <span class="textarea-title">{{ '+SERVICE_TICKET.CALL_FEEDBACK_TITLE' | translate }}</span>

  <mat-form-field mat-textarea>
    <span mat-textarea-limit class="textarea-limit">{{ additionalFeedback?.length || 0 }}/128</span>
    <span *ngIf="additionalFeedback?.length < minFeedbackLength" class="textarea-hint">{{
      '+GENERAL.AT_LEAST_CHARACTERS_LIMIT' | translate: { limit: minFeedbackLength }
    }}</span>
    <textarea
      gtm="onTextField"
      [gtmOn]="['change', 'focus', 'blur']"
      gtmAction="Feedback"
      gtmCategory="serviceTicket"
      data-at-feedback-input
      matInput
      maxlength="128"
      cdkTextareaAutosize
      cdkAutosizeMinRows="3"
      [value]="additionalFeedback"
      (input)="onInputValueChange($event)"
      [required]="true"
      placeholder="{{ '+SERVICE_TICKET.CALL_FEEDBACK_TEXTAREA_DESCRIPTION' | translate }}"
    ></textarea>
  </mat-form-field>
</div>
